import { SmokeDetectorIcon } from './SmokeDetectorIcon';

/**
 * author: Google
 * id 1DDC71A0-A86A-4E8F-BF1D-CD33C0B0BEA4
 * name smoke-detector
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/smoke-detector.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const SubwooferIcon = SmokeDetectorIcon;
export default SubwooferIcon